module.exports = __webpack_public_path__ + "static/media/4.8a6814a6.jpg";